/**
 * User-friendly display information for Celery task types.
 */

export interface TaskDisplayInfo {
	label: string;
	icon: "Search" | "AutoAwesome" | "HourglassBottom";
}

export const TASK_DISPLAY: Record<string, TaskDisplayInfo> = {
	"core.tasks.rebuild_gcq": {
		label: "Searching for candidates",
		icon: "Search",
	},
	"core.tasks.fill_llm_queue": {
		label: "Analyzing candidates",
		icon: "AutoAwesome",
	},
};

export const getTaskDisplayInfo = (taskName: string): TaskDisplayInfo => {
	return (
		TASK_DISPLAY[taskName] ?? {
			label: taskName,
			icon: "HourglassBottom",
		}
	);
};
